<template>
  <!-- 搜索模块-Start -->
  <b-overlay :show="loading" rounded="sm">
    <b-card-btn
      :title="i18n('searchCardTitle')"
      :body-visible="visible"
      :btn-visible="columnsOther.length > 0"
    >
      <template slot="base">
        <!-- advance search input -->
        <b-row>
          <b-col
            v-for="(col, col_i) in columnsBase"
            :key="col.field || col_i"
            :md="getSearchSpan(col)"
          >
            <b-form-group>
              <my-tooltip :tooltip="col.SearchTooltip" show-icon>
                <label>{{ col.label }}:</label>
              </my-tooltip>
              <div v-if="col.searchSlot">
                <slot :name="`${col.field}Search`" />
              </div>
              <element-component
                v-else
                v-model="searchForm[col.field]"
                :label="col.label"
                :option="col"
                :disabled="col.searchDisabled"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </template>
      <template slot="btns">
        <b-button class="btn cancel-btn" @click="searchReset">
          <feather-icon icon="RefreshCcwIcon" size="16" />
          {{ i18n('btns.reset') }}
        </b-button>

        <b-button class="btn primary-btn" @click="searchChange">
          <feather-icon icon="SearchIcon" size="16" />
          {{ i18n('btns.search') }}
        </b-button>
      </template>
      <!-- advance search input -->
      <b-row>
        <b-col
          v-for="(col, col_i) in columnsOther"
          :key="col.field || col_i"
          :md="getSearchSpan(col)"
        >
          <b-form-group>
            <my-tooltip :tooltip="col.SearchTooltip" show-icon>
              <label>{{ col.label }}:</label>
            </my-tooltip>
            <div v-if="col.searchSlot">
              <slot :name="`${col.field}Search`" />
            </div>
            <element-component
              v-else
              v-model="searchForm[col.field]"
              :label="col.label"
              :option="col"
              :disabled="col.searchDisabled"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-btn>
  </b-overlay>
  <!-- 搜索模块-End -->
</template>

<script>
import { BOverlay, BRow, BCol, BFormGroup, BButton } from 'bootstrap-vue'
import MyTooltip from '../myTooltip.vue'
import BCardBtn from '../BCardBtn.vue'
import ElementComponent from '../elementComponent.vue'

export default {
  name: 'CSearch',
  components: {
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    MyTooltip,
    BButton,
    BCardBtn,
    ElementComponent,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    searchSpan: {
      type: Number,
      default: 4,
    },
    form: {
      type: Object,
      default: () => {},
    },
    isEnterSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchForm: {},
    }
  },
  computed: {
    columnsBase() {
      const cols = []
      this.columns
        .filter((o) => o.searchBase)
        .forEach((item) => {
          const p = item
          const searchType = p.formOption
            ? p.formOption.searchType || p.searchType
            : p.searchType
          if (searchType) {
            p.type = searchType
          }
          cols.push(p)
        })
      return cols
    },
    columnsOther() {
      const cols = []
      this.columns
        .filter((o) => !o.searchBase)
        .forEach((item) => {
          const p = item
          const searchType = p.formOption
            ? p.formOption.searchType || p.searchType
            : p.searchType
          if (searchType) {
            p.type = searchType
          }
          cols.push(p)
        })
      return cols
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(e) {
        if (e) {
          console.log(e, 'form')
          this.$nextTick(() => {
            Object.keys(e).forEach((key) => {
              const element = e[key]
              this.searchForm[key] = element
            })
          })
          // Object.keys(e).forEach((key) => {
          //   const element = e[key]
          //   this.searchForm[key] = element
          // })
          console.log(e, 'e===')
          this.$emit('update:form', this.searchForm)
        }
      },
    },
  },
  created() {
    if (this.isEnterSearch) {
      this.getKeydown()
    }
    const temp = {}
    this.columns.forEach((item) => {
      if (item.search) {
        temp[item.field] = ''
      }
    })
    this.searchForm = temp
  },
  methods: {
    // 回车搜索
    getKeydown() {
      document.onkeydown = () => {
        const key = window.event.keyCode
        if (key === 13) {
          this.searchChange()
        }
      }
    },
    // 获取搜索项的栅格
    getSearchSpan(item) {
      if (item.searchSpan) {
        return item.searchSpan
      }
      return this.searchSpan
    },
    searchReset() {
      Object.keys(this.searchForm).forEach((key) => {
        this.searchForm[key] = undefined
      })
      this.$emit('searchReset')
    },
    searchChange() {
      this.$emit('searchChange', this.searchForm)
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  padding: 5px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  margin-left: 16px;
  svg {
    line-height: 22px;
    width: 14px;
    height: 14px;
    margin-bottom: 4px;
    margin-right: 6px;
  }
}
.cancel-btn {
  background-color: #ffffff !important;

  color: #606266 !important;
  border-radius: var(--Radius-border-radius-base, 4px);
  border: 1px solid var(--Color-Border-border-color, #dcdfe6) !important;
  background: var(--Color-Fill-fill-color-blank, #fff);
}
.cancel-btn:focus {
  background: #ffffff !important;
}
.primary-btn {
  border-radius: var(--Radius-border-radius-base, 4px);
  background: #7367f0 !important;
  border: none;
}
.primary-btn:focus {
  background: #7367f0 !important;
}
</style>
